<template>
  <div>
    <rest-form-item
      :label="$t('ChannelConfig_Etisalat_Email')"
      prop="params.email"
      :rules="requiredFieldRules"
    >
      <el-input
        v-model="model.params.email"
        :placeholder="$t('ChannelConfig_Etisalat_Email_Placeholder')"
        data-qa="email"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('ChannelConfig_Etisalat_Password')"
      prop="params.password"
      :rules="requiredFieldRules"
    >
      <el-input
        v-model="model.params.password"
        type="password"
        :placeholder="$t('ChannelConfig_Etisalat_Password_Placeholder')"
        data-qa="password"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('ChannelConfig_Etisalat_SenderId')"
      prop="params.sender_id"
      :description="$t('ChannelConfig_Etisalat_SenderId_Note')"
      :rules="requiredFieldRules"
    >
      <el-input
        v-model="model.params.sender_id"
        :placeholder="$t('ChannelConfig_Etisalat_SenderId_Placeholder')"
        data-qa="sender-id"
      />
    </rest-form-item>
  </div>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  components: { RestFormItem },
  props: {
    model: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      requiredFieldRules: [
        {
          required: true,
          message: this.$t('RestForm_FieldIsRequired'),
          trigger: 'blur'
        }
      ]
    }
  },

  created() {
    if (!this.$route.query.id) {
      this.$set(this.model, 'type', 'sms')
      this.$set(this.model, 'channel', 'etisalat')
      this.$set(this.model, 'params', {
        email: '',
        password: '',
        sender_id: ''
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/channels/providers/Etisalat.vue